<template>
  <div class="settings-block">
    <div class="place-content-center">
      <div class="icon-container">
        <div class="icon-box apply-loader">
          <slot name="icon"></slot>
        </div>
      </div>
      <div class="text-container">
        <h5 class="settings-block-title apply-loader">
          <slot name="title"></slot>
        </h5>
        <p class="settings-block-content apply-loader">
          <slot name="content"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsBlock",
};
</script>

<style scoped>
.settings-block-title {
  color: #0b0b0b;
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: normal;
  max-width: 95%;
  line-height: 1.2;
}
.settings-block-content {
  font-size: 18px;
  color: #918dab;
  margin: 0;
  padding: 5px 0 0 0;
  max-width: 95%;
}
.settings-block {
  width: 100%;
  border-bottom: 1px solid #918dab;
  padding: 10px 10px 14px 10px;
  overflow: hidden;
  background-color: #ffffff;
}
.place-content-center {
  display: flex;
  align-items: center;
  gap: 15px;
}
.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: #1aad62;
  color: #fff;
  width: 41px;
  height: 41px;
  border-radius: 30px;
}
.icon-container,
.text-container {
  position: relative;
}
@media (max-width: 340px) {
  .icon-container {
    width: 41px;
  }
  .text-container {
    width: calc(100% - 56px);
  }
}
@media (min-width: 340px) {
  .icon-container {
    width: 41px;
  }
  .text-container {
    width: calc(100% - 56px);
  }
}

.text-container {
  color: #0b0b0b;
  text-align: left;
  font-size: 16px;
  min-height: 41px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
